(function () {
  function initTrustBar(root) {
    if (!root || root.dataset.accYghLp0304Init === '1') return;
    root.dataset.accYghLp0304Init = '1';

    var slider = root.querySelector('.ACC_YGH_LP_03_04_slider');
    var track = root.querySelector('.ACC_YGH_LP_03_04_track');
    var list = root.querySelector('.ACC_YGH_LP_03_04_list');
    if (!slider || !track || !list) return;

    var mq = window.matchMedia('(max-width: 767px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var clone = null;
    var originalListHTML = list.innerHTML;
    var resizeFrame = null;

    function stripEditorAttrs(node) {
      node.removeAttribute('data-shopify-editor-block');
      node.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
        el.removeAttribute('data-shopify-editor-block');
      });
    }

    function restoreOriginalList() {
      list.innerHTML = originalListHTML;
    }

    /*
      One <ul> clone + translate3d(-50%) only loops seamlessly when each set
      is at least as wide as the viewport. On wide mobile (e.g. 767px) three
      short labels can fit on screen while the list is still narrower than the
      slider, leaving empty space before the duplicate set enters.
    */
    function padListForSeamlessMarquee() {
      restoreOriginalList();

      var minWidth = slider.clientWidth + 48;
      var baseItems = Array.prototype.slice.call(list.children);
      if (!baseItems.length) return;

      var guard = 0;
      while (list.scrollWidth < minWidth && guard < 24) {
        baseItems.forEach(function (item) {
          var copy = item.cloneNode(true);
          stripEditorAttrs(copy);
          list.appendChild(copy);
        });
        guard += 1;
      }
    }

    function clearClone() {
      if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
      clone = null;
      track.classList.remove('is-marquee', 'is-paused');
      restoreOriginalList();
    }

    function ensureClone() {
      if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
      clone = null;

      padListForSeamlessMarquee();

      clone = list.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      stripEditorAttrs(clone);
      track.appendChild(clone);
    }

    function pause() {
      track.classList.add('is-paused');
    }

    function resume() {
      track.classList.remove('is-paused');
    }

    function sync() {
      if (mq.matches && !reduceMotion.matches) {
        ensureClone();
        track.classList.add('is-marquee');
      } else {
        clearClone();
      }
    }

    function scheduleSync() {
      if (resizeFrame !== null) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = null;
        sync();
      });
    }

    slider.addEventListener('pointerdown', pause);
    slider.addEventListener('pointerup', resume);
    slider.addEventListener('pointerleave', resume);
    slider.addEventListener('pointercancel', resume);

    sync();

    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else {
      mq.addListener(sync);
    }

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', sync);
    } else {
      reduceMotion.addListener(sync);
    }

    window.addEventListener('resize', scheduleSync);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleSync);
    }
  }

  function init() {
    var root = document.querySelector('#ACC_YGH_LP_03_04');
    if (root) initTrustBar(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.target &&
      event.target.querySelector &&
      event.target.querySelector('#ACC_YGH_LP_03_04')
    ) {
      var root = event.target.querySelector('#ACC_YGH_LP_03_04');
      delete root.dataset.accYghLp0304Init;
      initTrustBar(root);
    }
  });
})();
